module.exports = __webpack_public_path__ + "35701165acd4c5fb55585f8406614d7a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/vert_asset_management.png
// module id = 1879
// module chunks = 0